import { Paper } from "@mui/material";
import React from "react";

import { theme } from "../../utils/theme";

const Card = ({ children }) => {
  return (
    <Paper
      variant="outlined"
      sx={{
        backgroundColor: theme.palette.grays[100],
        borderRadius: 3,
        my: 4,
        px: 6,
        py: 5,
      }}
    >
      {children}
    </Paper>
  );
};

export default Card;
